import {IGatsbyImageData} from 'gatsby-plugin-image/dist/src/components/gatsby-image.browser';
import {GatsbyImageProps} from "gatsby-image";
import {IGatsbyImageDataParent} from "gatsby-plugin-image/dist/src/components/hooks";


export interface IWpPostWithSlug {
  translated: postTranslated
  slug: string;
  id: string;
  title: string;
  locale: {
    locale: string;
  }
  excerpt: string;
  date: string;
  categories: AllWpCategoriesWithSlug;
  contentType: {
    node: {
      name: ContentType
    }
  }
  featuredImage?: {
    node: IGatsbyImageData
  };
  seo: {
    metaDesc: string;
    canonical: string;
    title: string;
    opengraphTitle: string;
    opengraphDescription: string
    opengraphUrl: string
    opengraphImage: {
      sourceUrl: string;
    }
  }
}

export type postTranslated = {
  translated: {
    id: string;
    slug: string;
    locale: {
      locale: string;
    }
  }[]
}

export type FeaturedImage = {
  node: {
    sourceUrl: string,
    srcSet: string,
    altText: string,
  }
}

export type AllWpPostsWithSlug = {
  edges: {
    node: IWpPostWithSlug
  }[]
}

export interface IWpCategoryWithSlug {
  id: string;
  slug: string;
  uri: string;
  name: string;
}

export interface IWpCategoryWithSlugAndLocale extends IWpCategoryWithSlug {
  locale: string
}

export type AllWpCategoriesWithSlug = {
  edges: {
    isPrimary: boolean;
    node: IWpCategoryWithSlug;
  }[]
}

export interface IWpArticlePost extends IWpPostWithSlug {
  articleContent: {
    videoYoutube?: string;
    articleBody: string;
    articleType: string;
    author: IWpAuthor[]
  }
}

export interface IWpVideoPost extends IWpPostWithSlug {
  videoContent: {
    videoYoutube: string;
    author: IWpAuthor[]
  }
}

export interface IWpGuidePost extends IWpPostWithSlug {
  guideContent: {
    guideBody: string;
    author: IWpAuthor[]
  }
}

export interface IWpAuthor {
  article_author : {
    authorName: string;
    authorPicture: {
      altText: string;
      srcSet: string;
      sourceUrl: string;
    }
  }
}

export enum ContentType {
  article = 'article',
  video = 'video',
  guide = 'guide',
}

export type AllWpBanners = {
  edges: {
    node: WpBanner
  }[]
}

export type WpBanner = {
  edges: any;
  id: string;
  slug: string;
  locale: {
    locale: string;
  }
  title: string;
  bannerProperties: {
    bannerUrl: string;
    bannerImage: IGatsbyImageData
    bannerMobileImage: IGatsbyImageData
  }
}

export type FeaturedArticles = {
  node: {
    featuredParentsArticles: {
      articlesForParents?: FeaturedArticle[]
      articlesForGrandparents?: FeaturedArticle[]
      articlesForMedical?: FeaturedArticle[]
    }
    locale: {
      locale: string;
    }
  }
}

export type FeaturedArticle = {
  __typename: string;
  id: string;
}

export enum BannerSlug {
  A = 'banner-a',
  B = 'banner-b'
}
